import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { FaEdit, FaTrash } from 'react-icons/fa';
import OrganisationModal from './OrganisationModal';
import ReactPaginate from 'react-paginate';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../../context/AuthContext';
import withPermission from '../../../utils/withPermission';
import Swal from 'sweetalert2';
import { Card } from 'react-bootstrap';
import OrganisationSlideModal from './OrganisationSlideModal';
import { FaFilter } from "react-icons/fa";
import { saveAs } from "file-saver";
import OrganisationDetails from './OrganisationDetails';


const OrganisationList = ({ }) => {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const orgTypeParam = queryParams.get('org_type');

    const [contacts, setOrganisation] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [selectedOrganisationId, setSelectedOrganisationId] = useState(null);
    const [selectedOrganisationData, setSelectedOrganisationData] = useState(null);
    const [currentPage, setCurrentPage] = useState(0);
    const [pageCount, setPageCount] = useState(0);
    const [countries, setCountries] = useState([]);
    const [errors, setErrors] = useState({});
    const [industries, setIndustries] = useState([]);
    const WithCreatePermission = withPermission(({ children }) => children, ['organisation-create']);
    const WithEditPermission = withPermission(({ children }) => children, ['organisation-edit']);
    const WithDeletePermission = withPermission(({ children }) => children, ['organisation-delete']);
    const didFetchRef = useRef(false);
    const [searchQuery, setSearchQuery] = useState('');
    const debounceTimeoutRef = useRef(null);
    const [showSlideModal, setShowSlideModal] = useState(false);
    const didInitialFetch = useRef(false);
    const [sectorFilter, setSectorFilter] = useState('');
    const [typeFilter, setTypeFilter] = useState('');
    const [filterDropdown, setFilterDropdown] = useState(null);
    const [showOffcanvas, setShowOffcanvas] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [showDetailsOffcanvas, setShowDetailsOffcanvas] = useState(false);
    const [selectedOrganisationForEdit, setSelectedOrganisationForEdit] = useState(null);
    const [salesUsers, setSalesUsers] = useState([]);
    const [salesUserFilter, setSalesUserFilter] = useState('');
    const [userData, setUserData] = useState(null);
    const [scopeFilter, setScopeFilter] = useState('');

    useEffect(() => {
        if (orgTypeParam) {
            setTypeFilter(orgTypeParam);
        } else {
            setTypeFilter('');
        }
    }, [orgTypeParam]);

    useEffect(() => {
        const userInfo = JSON.parse(localStorage.getItem('user-info'));
        setUserData(userInfo);
        if (userInfo?.user?.roles?.some(r => r.data_scope === 'all' || r.name === 'superadmin')) {
            fetchSalesUsers();
        }
        // fetchOrganisation(); // fetch initial page
        // fetchIndustries();
    }, []);
    useEffect(() => {
        if (debounceTimeoutRef.current) {
            clearTimeout(debounceTimeoutRef.current);
        }

        debounceTimeoutRef.current = setTimeout(() => {
            fetchOrganisation(1, searchQuery);
        }, searchQuery ? 1500 : 0);

        return () => {
            if (debounceTimeoutRef.current) {
                clearTimeout(debounceTimeoutRef.current);
            }
        };
    }, [searchQuery, typeFilter, sectorFilter, salesUserFilter, scopeFilter]); // Add typeFilter and sectorFilter to the dependency array
    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);

    };
    const fetchOrganisation = async (page = 1) => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');

            const token = userInfo?.token;
            let params = { page };

            if (searchQuery) params.search = searchQuery;
            if (sectorFilter) params.industry_id = sectorFilter; // Only add if not empty
            if (typeFilter) params.org_type = typeFilter;
            if (salesUserFilter) params.created_by = salesUserFilter;
            if (scopeFilter) params.scope = scopeFilter;

            params.order_by = 'name';
            params.order_direction = 'asc';
            // Also include sort_by/sort_direction/sortBy in case the backend uses those keys
            params.sort_by = 'name';
            params.sort_direction = 'asc';
            params.sortBy = 'name';
            params.sortOrder = 'asc';

            const response = await axios.get(`${backendUrl}/api/organisation`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                params,
            });

            const { data, current_page, last_page } = response.data.data;

            setOrganisation(data);
            setCurrentPage(current_page - 1);
            setPageCount(last_page);
        } catch (error) {
            console.error(`Error fetching :`, error);
        }
    };
    const fetchIndustries = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;

            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');

            const token = userInfo?.token;

            let allIndustries = [];
            let currentPage = 1;
            let lastPage = 1;


            const response = await axios.get(`${backendUrl}/api/industries`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                skipLoader: true,

            });

            allIndustries = [...allIndustries, ...response.data.industry]


            setIndustries(allIndustries);
        } catch (error) {
            console.error('Error fetching industries:', error);
        }
    };

    const fetchSalesUsers = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const response = await axios.get(`${backendUrl}/api/users?role=Inside%20Sales`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                skipLoader: true,
            });
            setSalesUsers(response.data.Data || []);
        } catch (error) {
            console.error('Error fetching sales users:', error);
        }
    };
    useEffect(() => {
        fetchIndustries();
    }, []);
    const addOrganisation = async (newOrganisation) => {
        try {
            const formData = new FormData();
            // Append regular fields
            Object.keys(newOrganisation).forEach((key) => {
                formData.append(key, newOrganisation[key]);
            });


            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');

            const token = userInfo?.token;

            // Corrected API endpoint with dynamic contact_type for adding
            const response = await axios.post(`${backendUrl}/api/organisation`, formData, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,

                },
            });
            const createdOrganisation = response.data.data;

            if (createdOrganisation) {
                setOrganisation((prevOrganisation) => [...prevOrganisation, createdOrganisation]);
            } else {
                console.error('Creation failed, no data returned.');
            }

                handleCloseModal();
                fetchOrganisation(currentPage + 1);

                Toast.fire({
                    icon: "success",
                    title: "Organisation added successfully!",
                });
        } catch (error) {
            if (error.response?.data?.errors) {
                return error.response.data.errors; // Return validation errors
            } else {
                console.error(`Error adding organisation`, error);
            }
        }
    };


    const editOrganisation = async (contactId, updatedData) => {
        try {

            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');

            const token = userInfo?.token;

            // Corrected API endpoint with dynamic contact_type for editing
            const response = await axios.put(`${backendUrl}/api/organisation/${contactId}`, updatedData, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,

                },
            });
            const updatedOrganisation = response.data.Data;

            if (updatedOrganisation) {
                setOrganisation((prevOrganisation) =>
                    prevOrganisation.map((contact) => (contact.id === updatedOrganisation.id ? updatedOrganisation : contact))
                );

            } else {
                console.error('Update failed, no data returned.');
            }

                handleCloseModal();
                fetchOrganisation(currentPage + 1);

                Toast.fire({
                    icon: "success",
                    title: "Organisation updated successfully!",
                });
        } catch (error) {
            if (error.response?.data?.errors) {
                return error.response.data.errors; // Return validation errors
            } else
                console.error(`Error updating`, error);
        }
    };
    const handleShowEditModal = (organisationId = null) => {
        if (organisationId) {
            const organisationToEdit = contacts.find((org) => org.id === organisationId);
            if (organisationToEdit) {
                setSelectedOrganisationForEdit(organisationToEdit);
            }
        } else {
            setSelectedOrganisationForEdit(null);
        }
        setSelectedOrganisationId(organisationId);
        setShowEditModal(true);
    };

    const handleCloseEditModal = () => {
        setShowEditModal(false);
        setSelectedOrganisationId(null);
        setSelectedOrganisationForEdit(null);
        setErrors({});
    };

    const handleShowDetails = (organisationId) => {
        setSelectedOrganisationId(organisationId);
        setShowDetailsOffcanvas(true);
    };

    const handleCloseDetails = () => {
        setShowDetailsOffcanvas(false);
        setSelectedOrganisationId(null);
    };
    const deleteOrganisation = async (id) => {
        Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Yes, delete it!"
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const backendUrl = process.env.REACT_APP_BACKEND_URL;
                    const userInfo = JSON.parse(localStorage.getItem('user-info'));
                    const origin = localStorage.getItem('user-origin');

                    const token = userInfo?.token;

                    // Corrected API endpoint with dynamic contact_type for deleting
                    await axios.delete(`${backendUrl}/api/organisation/delete/${id}`, {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            'Tenant-Origin': origin,
                        },
                    });

                    setOrganisation(contacts.filter((contact) => contact.id !== id));
                    fetchOrganisation(currentPage + 1);
                    Toast.fire({
                        icon: "success",
                        title: "Organisation deleted successfully!",
                    });
                    Swal.fire(
                        "Deleted!",
                        "The organisation has been deleted.",
                        "success"
                    );
                } catch (error) {
                    console.error('Error deleting organisation:', error);
                    Swal.fire(
                        "Error!",
                        "Failed to delete organisation. Please try again.",
                        "error"
                    );
                }
            }
        });
    };

    const handleShowModal = (contactId = null) => {
        if (contactId) {
            const contactToEdit = contacts.find((contact) => contact.id === contactId);
            if (contactToEdit) {
                setSelectedOrganisationData(contactToEdit);
            }
        } else {
            setSelectedOrganisationData(null);
        }
        setSelectedOrganisationId(contactId);
        // setShowModal(true);
        setShowSlideModal(true);

    };
    const handleShowSlideModal = () => {
        setSelectedOrganisationData(null);
        setSelectedOrganisationId(null);
        setShowSlideModal(true);
    };
    const handleCloseModal = () => {
        setShowModal(false);
        setShowSlideModal(false);

        setSelectedOrganisationId(null);
        setSelectedOrganisationData(null);
        setErrors({});
    };

    const handlePageClick = (data) => {
        const selectedPage = data.selected + 1;
        fetchOrganisation(selectedPage);
    };
    const getIndustryNameById = (industryId) => {
        const industry = industries.find(industry => industry.id == industryId);
        return industry ? industry.name : '';
    };
    const formatOrgType = (type) => {
        if (!type) return ''; // Return empty string if type is null or undefined
        return type.charAt(0).toUpperCase() + type.slice(1).toLowerCase().replace(/_/g, ' ');
    };

    const [viewType, setViewType] = useState('list');
    const handleFilterChange = (filterType, value) => {
        if (filterType === 'sector') setSectorFilter(value);
        if (filterType === 'type') setTypeFilter(value);

        setFilterDropdown(null); // Close dropdown after selection
    };

    const handleExportOrganizations = async () => {
        try {
            const userInfo = JSON.parse(localStorage.getItem("user-info"));
            const origin = localStorage.getItem("user-origin");
            const token = userInfo?.token;

            const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/organizations/export`, {
                responseType: "blob",
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Tenant-Origin": origin,
                },
            });

            const blob = new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
            saveAs(blob, `organizations_${new Date().toISOString().split('T')[0]}.xlsx`);

            Toast.fire({
                icon: "success",
                title: "Organizations exported successfully!",
            });
        } catch (error) {
            console.error("Export error:", error);
            Toast.fire({
                icon: "error",
                title: "Export failed! Please try again.",
            });
        }
    };
    const Toast = Swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
            toast.onmouseenter = Swal.stopTimer;
            toast.onmouseleave = Swal.resumeTimer;
        },
    });
    const handleImportOrganizations = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const formData = new FormData();
        formData.append("file", file);

        try {
            const userInfo = JSON.parse(localStorage.getItem("user-info"));
            const origin = localStorage.getItem("user-origin");
            const token = userInfo?.token;

            await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/organizations/import`, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    Authorization: `Bearer ${token}`,
                    "Tenant-Origin": origin,
                },
            });

            Toast.fire({
                icon: "success",
                title: "Organizations imported successfully!",
            });

            setTimeout(() => window.location.reload(), 1000);
        } catch (error) {
            console.error("Import error:", error);
            Toast.fire({
                icon: "error",
                title: "Import failed! Please check your file.",
            });
        }
    };


    return (
        <div className="main-content">
            <div className="page-content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12">
                            <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                                <h4 className="mb-sm-0 font-size-18">
                                    Organisations
                                </h4>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-12">
                            {viewType === 'list' ? (
                                <div className="card">
                                    <div className="card-body">
                                        {/* <div className="d-flex justify-content-end mb-3"> */}
                                        <div className="d-flex justify-content-between mb-3">
                                            <div className="d-flex">
                                                <div className="search-box me-2 mb-2 d-inline-block">
                                                    <div className="position-relative">
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            placeholder="Search..."
                                                            value={searchQuery}
                                                            onChange={handleSearchChange}
                                                        />
                                                        <i className="bx bx-search-alt search-icon" />
                                                    </div>
                                                </div>



                                            </div>

                                            {userData?.user?.roles?.some(r => r.data_scope === 'all' || r.name === 'superadmin' || r.data_scope === 'team') && (
                                                <div className="me-2 mb-2 d-inline-block">
                                                    <select
                                                        className="form-select"
                                                        value={scopeFilter}
                                                        onChange={(e) => setScopeFilter(e.target.value)}
                                                        style={{ height: '38px' }}
                                                    >
                                                        <option value="">Data Scope (All)</option>
                                                        <option value="self">Self</option>
                                                        {userData?.user?.roles?.some(r => r.data_scope === 'all' || r.name === 'superadmin' || r.data_scope === 'team') && (
                                                            <option value="team">Team</option>
                                                        )}
                                                        {userData?.user?.roles?.some(r => r.data_scope === 'all' || r.name === 'superadmin') && (
                                                            <option value="all">Shared</option>
                                                        )}
                                                    </select>
                                                </div>
                                            )}

                                            {userData?.user?.roles?.some(r => r.data_scope === 'all' || r.name === 'superadmin') && (
                                                <div className="me-2 mb-2 d-inline-block">
                                                    <select
                                                        className="form-select"
                                                        value={salesUserFilter}
                                                        onChange={(e) => setSalesUserFilter(e.target.value)}
                                                        style={{ height: '38px' }}
                                                    >
                                                        <option value="">All Sales Persons</option>
                                                        {salesUsers.map(user => (
                                                            <option key={user.id} value={user.id}>{user.name}</option>
                                                        ))}
                                                    </select>
                                                </div>
                                            )}
                                            {/* <div className="d-flex align-items-center">
                                                <div>
                                                    <ul className="nav nav-pills justify-content-end">
                                                        <li className="nav-item">
                                                            <a className="nav-link disabled" href="#" tabIndex={-1} aria-disabled="true"></a>
                                                        </li>
                                                        <li className="nav-item nav-icon" data-bs-placement="top" title="List">
                                                            <a
                                                                className={`nav-link ${viewType === 'list' ? 'bg-primary bg-soft font-size-13' : ''}`}
                                                                href="#"
                                                                onClick={() => setViewType('list')}
                                                            >
                                                                <i className="mdi mdi-format-list-bulleted" />
                                                            </a>
                                                        </li>
                                                        <li className="nav-item nav-icon" data-bs-placement="top" title="Grid">
                                                            <a
                                                                className={`nav-link ${viewType === 'grid' ? 'bg-primary bg-soft' : ''}`}
                                                                href="#"
                                                                onClick={() => setViewType('grid')}
                                                            >
                                                                <i className="mdi mdi-view-grid-outline" />
                                                            </a>
                                                        </li>
                                                    </ul>
                                                </div>


                                               
                                                <WithCreatePermission>
                                                    <button
                                                        type="button"
                                                        className="btn rounded-circle border d-flex align-items-center justify-content-center round-create-button"

                                                        onClick={handleShowSlideModal}
                                                        data-bs-toggle="tooltip"
                                                        data-bs-placement="top"
                                                        title="Add Organisation"
                                                    >
                                                        <i className="mdi mdi-plus"></i>
                                                    </button>
                                                </WithCreatePermission>

                                            </div> */}
                                            <div className="d-flex align-items-center gap-2">
                                                {/* Export Button */}
                                                <button
                                                    type="button"
                                                    className="btn btn-light border"
                                                    onClick={handleExportOrganizations}
                                                    data-bs-toggle="tooltip"
                                                    data-bs-placement="top"
                                                    title="Export Organizations to Excel"
                                                >
                                                    <i className="mdi mdi-file-excel text-success"></i>
                                                </button>

                                                {/* Import Button */}
                                                <input
                                                    type="file"
                                                    accept=".xlsx, .xls"
                                                    id="importOrganizationsFile"
                                                    onChange={handleImportOrganizations}
                                                    style={{ display: "none" }}
                                                />
                                                <label
                                                    htmlFor="importOrganizationsFile"
                                                    className="btn btn-light border mb-0"
                                                    data-bs-toggle="tooltip"
                                                    data-bs-placement="top"
                                                    title="Import Organizations from Excel"
                                                >
                                                    <i className="mdi mdi-upload text-primary"></i>
                                                </label>

                                                {/* Add Organization Button */}
                                                <WithCreatePermission>
                                                    <button
                                                        type="button"
                                                        className="btn rounded-circle border d-flex align-items-center justify-content-center round-create-button"
                                                        onClick={() => handleShowSlideModal()}
                                                        data-bs-toggle="tooltip"
                                                        data-bs-placement="top"
                                                        title="Add Organization"
                                                    >
                                                        <i className="mdi mdi-plus"></i>
                                                    </button>
                                                </WithCreatePermission>
                                            </div>
                                        </div>

                                        {/* <table className="table align-middle table-nowrap table-hover table-check table-list" style={{ tableLayout: 'fixed', width: '100%' }}>
                                            <thead className="table-light">
                                                <tr>
                                                    <th style={{ width: '5%' }} className="align-middle">
                                                        <div className="form-check font-size-16">
                                                            <input className="form-check-input" type="checkbox" id="checkAll" />
                                                            <label className="form-check-label" htmlFor="checkAll"></label>
                                                        </div>
                                                    </th>
                                                    <th style={{ width: '5%' }} className="align-middle">#</th>
                                                    <th style={{ width: '25%' }} className="align-middle text-start">Name</th>
                                                    <th style={{ width: '15%' }} className="align-middle">Employee Size</th>
                                                    <th style={{ width: '20%' }} className="align-middle">Sector
                                                        <div className="dropdown d-inline-block">
                                                            <FaFilter
                                                                className="ms-2 cursor-pointer filter-color"
                                                                onClick={() => setFilterDropdown(filterDropdown === 'sector' ? null : 'sector')}
                                                            />
                                                            {filterDropdown === 'sector' && (
                                                                <ul className="dropdown-menu show">
                                                                    <li><button className="dropdown-item" onClick={() => handleFilterChange('sector', '')}>All</button></li>
                                                                    {industries.map((type) => (
                                                                        <li key={type.id}>
                                                                            <button className="dropdown-item" onClick={() => handleFilterChange('sector', type.id)}>
                                                                                {type.name}
                                                                            </button>
                                                                        </li>
                                                                    ))}
                                                                </ul>
                                                            )}
                                                        </div>
                                                    </th>
                                                    <th style={{ width: '15%' }} className="align-middle">Type
                                                        <div className="dropdown d-inline-block">
                                                            <FaFilter
                                                                className="ms-2 cursor-pointer filter-color"
                                                                onClick={() => setFilterDropdown(filterDropdown === 'type' ? null : 'type')}
                                                            />
                                                            {filterDropdown === 'type' && (
                                                                <ul className="dropdown-menu show">
                                                                    <li>
                                                                        <button className="dropdown-item" onClick={() => handleFilterChange('type', '')}>
                                                                            All
                                                                        </button>
                                                                    </li>
                                                                    <li>
                                                                        <button className="dropdown-item" onClick={() => handleFilterChange('type', 'partner')}>
                                                                            Partner
                                                                        </button>
                                                                    </li>
                                                                    <li>
                                                                        <button className="dropdown-item" onClick={() => handleFilterChange('type', 'end customer')}>
                                                                            End Customer
                                                                        </button>
                                                                    </li>
                                                                </ul>
                                                            )}
                                                        </div>
                                                    </th>
                                                    <th style={{ width: '15%' }} className="align-middle">Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {contacts.length > 0 ? (
                                                    contacts.map((client, index) => (
                                                        <tr key={client.id}>
                                                            <td style={{ width: '5%' }}>
                                                                <div className="form-check font-size-16">
                                                                    <input
                                                                        className="form-check-input"
                                                                        type="checkbox"
                                                                        id={`clientCheck${index}`}
                                                                    />
                                                                    <label
                                                                        className="form-check-label"
                                                                        htmlFor={`clientCheck${index}`}
                                                                    ></label>
                                                                </div>
                                                            </td>
                                                            <td style={{ width: '5%' }}>{index + 1}</td>

                                                            <td style={{ width: '25%' }} className='text-start'>
                                                                      <button
                                                                                className="dropdown-item text-start p-0 border-0 bg-transparent"
                                                                                onClick={() => handleShowDetails(client.id)}
                                                                                style={{ textAlign: 'left' }}
                                                                            >
                                                                    {client.name}
                                                                    </button>
                                                            </td>
                                                            <td style={{ width: '15%' }}>{client.employee_size}</td>
                                                            <td style={{ width: '20%' }}>{client.industry?.name}</td>

                                                            <td style={{ width: '15%' }}>{formatOrgType(client.org_type)}</td>

                                                            <td style={{ width: '15%' }}>
                                                                <div className="dropdown font-size-13">
                                                                    <i
                                                                        className="mdi mdi-dots-horizontal font-size-17"
                                                                        data-bs-toggle="dropdown"
                                                                        aria-expanded="false"
                                                                        style={{ cursor: 'pointer' }}
                                                                    ></i>
                                                                    <ul className="dropdown-menu dropdown-menu-end font-size-14">
                                                                        <li>
                                                                           
                                                                            <button
                                                                                className="dropdown-item"
                                                                                onClick={() => handleShowDetails(client.id)}

                                                                            >
                                                                                View Details
                                                                            </button>
                                                                        </li>
                                                                        <li><WithEditPermission>
                                                                            <button
                                                                                className="dropdown-item"
                                                                                onClick={() => handleShowModal(client.id)}
                                                                            >
                                                                                Edit
                                                                            </button></WithEditPermission>
                                                                        </li>
                                                                        <li><WithDeletePermission>
                                                                            <button
                                                                                className="dropdown-item"
                                                                                onClick={() => deleteOrganisation(client.id)}
                                                                            >
                                                                                Delete
                                                                            </button></WithDeletePermission>
                                                                        </li>
                                                                    </ul>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan="7" className="text-center">No clients found.</td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table> */}
                                        <table
                                            className="table align-middle table-hover table-check table-list"
                                            style={{ tableLayout: 'fixed', width: '100%' }}
                                        >
                                            <thead className="table-light text-center">
                                                <tr>
                                                    <th style={{ width: '12%' }} className="align-middle text-center p-2">
                                                        <div className="d-flex justify-content-center align-items-center gap-2">
                                                            <input
                                                                className="form-check-input m-0"
                                                                type="checkbox"
                                                                id="checkAll"
                                                            />&nbsp;&nbsp;&nbsp;&nbsp;
                                                            <span>#</span>
                                                        </div>
                                                    </th>
                                                    <th style={{ width: '6%' }} className="align-middle text-start p-2">Name</th>
                                                    <th style={{ width: '14%' }} className="align-middle text-center p-2">Short Code</th>

                                                    <th style={{ width: '14%' }} className="align-middle text-center p-2">Sector</th>
                                                    <th style={{ width: '14%' }} className="align-middle text-center p-2">Type</th>
                                                    <th style={{ width: '14%' }} className="align-middle text-center p-2">Employee Size</th>

                                                    <th style={{ width: '14%' }} className="align-middle text-center p-2">Action</th>
                                                </tr>
                                            </thead>

                                            <tbody>
                                                {contacts.length > 0 ? (
                                                    contacts.map((client, index) => (
                                                        <tr key={client.id}>
                                                            {/* Combined checkbox + number */}
                                                            <td style={{ width: '12%' }} className="p-2 text-center">
                                                                <div className="d-flex justify-content-center align-items-center gap-2">
                                                                    <input
                                                                        className="form-check-input m-0"
                                                                        type="checkbox"
                                                                        id={`clientCheck${index}`}
                                                                    />&nbsp;&nbsp;&nbsp;&nbsp;
                                                                    <span>{index + 1}</span>
                                                                </div>
                                                            </td>

                                                            {/* Name */}
                                                            <td style={{ width: '14%' }} className="p-2 text-start">
                                                                <button
                                                                    className="dropdown-item text-start p-0 border-0 bg-transparent narration-cell" title={client.name || ''}
                                                                    onClick={() => handleShowDetails(client.id)}
                                                                >
                                                                    {client.name}
                                                                </button>
                                                            </td>
                                                            <td style={{ width: '14%' }} className="p-2 text-center">

                                                                {client.short_code}
                                                            </td>

                                                            {/* Employee size */}


                                                            {/* Sector */}
                                                            <td style={{ width: '14%' }} className="p-2 text-center narration-cell" title={client.industry?.name || ''}>
                                                                {client.industry?.name}
                                                            </td>

                                                            {/* Type */}
                                                            <td style={{ width: '14%' }} className="p-2 text-center">
                                                                {formatOrgType(client.org_type)}
                                                            </td>
                                                            <td style={{ width: '14%' }} className="p-2 text-center">
                                                                {client.employee_size}
                                                            </td>

                                                            {/* Action */}
                                                            <td style={{ width: '14%' }} className="p-2 text-center">
                                                                <div className="dropdown font-size-13">
                                                                    <i
                                                                        className="mdi mdi-dots-horizontal font-size-17"
                                                                        data-bs-toggle="dropdown"
                                                                        aria-expanded="false"
                                                                        style={{ cursor: 'pointer' }}
                                                                    ></i>
                                                                    <ul className="dropdown-menu dropdown-menu-end font-size-14">
                                                                        <li>
                                                                            <button
                                                                                className="dropdown-item"
                                                                                onClick={() => handleShowDetails(client.id)}
                                                                            >
                                                                                View Details
                                                                            </button>
                                                                        </li>
                                                                        <li>
                                                                            <WithEditPermission>
                                                                                <button
                                                                                    className="dropdown-item"
                                                                                    onClick={() => handleShowModal(client.id)}
                                                                                >
                                                                                    Edit
                                                                                </button>
                                                                            </WithEditPermission>
                                                                        </li>
                                                                        <li>
                                                                            <WithDeletePermission>
                                                                                <button
                                                                                    className="dropdown-item"
                                                                                    onClick={() => deleteOrganisation(client.id)}
                                                                                >
                                                                                    Delete
                                                                                </button>
                                                                            </WithDeletePermission>
                                                                        </li>
                                                                    </ul>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan="6" className="text-center">No clients found.</td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>



                                        <div className="d-flex justify-content-end pagination-sm">
                                            <ReactPaginate
                                                previousLabel={'<'}
                                                nextLabel={'>'}
                                                breakLabel={'...'}
                                                pageCount={pageCount}
                                                marginPagesDisplayed={2}
                                                pageRangeDisplayed={3}
                                                onPageChange={handlePageClick}
                                                containerClassName={'pagination pagination-rounded justify-content-end mb-2'}
                                                pageClassName={'page-item'}
                                                pageLinkClassName={'page-link'}
                                                previousClassName={'page-item previous'}
                                                previousLinkClassName={'page-link'}
                                                nextClassName={'page-item next'}
                                                nextLinkClassName={'page-link'}
                                                breakClassName={'page-item'}
                                                breakLinkClassName={'page-link'}
                                                activeClassName={'active'}
                                            />
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                <div className="row">
                                    <div className='d-flex align-items-center justify-content-end '>
                                        <div>
                                            <ul className="nav nav-pills justify-content-end">
                                                <li className="nav-item">
                                                    <a className="nav-link disabled" href="#" tabIndex={-1} aria-disabled="true"></a>
                                                </li>
                                                <li className="nav-item" data-bs-placement="top" title="List">
                                                    <a
                                                        className={`nav-link ${viewType === 'list' ? 'bg-primary bg-soft' : ''}`}
                                                        href="#"
                                                        onClick={() => setViewType('list')}
                                                    >
                                                        <i className="mdi mdi-format-list-bulleted" />
                                                    </a>
                                                </li>
                                                <li className="nav-item" data-bs-placement="top" title="Grid">
                                                    <a
                                                        className={`nav-link ${viewType === 'grid' ? 'bg-primary bg-soft' : ''}`}
                                                        href="#"
                                                        onClick={() => setViewType('grid')}
                                                    >
                                                        <i className="mdi mdi-view-grid-outline" />
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>&nbsp;&nbsp;
                                        <WithCreatePermission>
                                            <button
                                                type="button"
                                                className="btn rounded-circle border d-flex align-items-center justify-content-center"
                                                style={{
                                                    width: "30px",
                                                    height: "30px",
                                                    padding: "5px",
                                                    backgroundColor: "rgb(201 227 236)",
                                                    borderColor: "#ccc",
                                                    color: "#333",
                                                }}
                                                onClick={() => handleShowModal()}
                                                data-bs-toggle="tooltip"
                                                data-bs-placement="top"
                                                id="tool"
                                                title="Add Deal"
                                            >
                                                <i className="mdi mdi-plus" style={{ fontSize: "16px" }}></i>
                                            </button></WithCreatePermission>
                                    </div>
                                    {contacts.length > 0 ? (
                                        contacts.map((deal, index) => (
                                            <div key={deal.id} className="col-xl-4 col-sm-6">
                                                <Card className='ccard1'>
                                                    <Card.Body>
                                                        <div className="d-flex">
                                                            <div className="flex-shrink-0 me-4">
                                                                <div className="avatar-md">
                                                                    <span className="avatar-title rounded-circle bg-light text-success font-size-16">
                                                                        {deal.name ? deal.name[0].toUpperCase() : 'N'}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                            <div className="flex-grow-1 overflow-hidden">
                                                                <h5 className="text-truncate font-size-15">
                                                                    <Link to={`/organisation/details/${deal.id}`} className="dropdown-item text-dark">{deal.name}</Link>
                                                                </h5>
                                                                <p className="text-muted mb-4">{deal.org_type}</p>
                                                                <div className="avatar-group">
                                                                    <div className="avatar-group-item">
                                                                        <p className="text-muted mb-4">{deal.industry?.name}</p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Card.Body>
                                                    <div className="px-4 py-3 border-top">
                                                        <ul className="list-inline mb-0">

                                                            <li className="list-inline-item me-3">
                                                                <i className="bx bx-calendar me-1" />
                                                                {new Date(deal.created_at).toISOString().split("T")[0]}
                                                            </li>

                                                        </ul>
                                                    </div>
                                                </Card>
                                            </div>

                                        ))
                                    ) : (
                                        <p>No deals found.</p>
                                    )}
                                    <div className="d-flex justify-content-end pagination-sm">
                                        <ReactPaginate
                                            previousLabel={'<'}
                                            nextLabel={'>'}
                                            breakLabel={'...'}
                                            pageCount={pageCount}
                                            marginPagesDisplayed={2}
                                            pageRangeDisplayed={3}
                                            onPageChange={handlePageClick}
                                            containerClassName={'pagination pagination-rounded justify-content-end mb-2'}
                                            pageClassName={'page-item'}
                                            pageLinkClassName={'page-link'}
                                            previousClassName={'page-item previous'}
                                            previousLinkClassName={'page-link'}
                                            nextClassName={'page-item next'}
                                            nextLinkClassName={'page-link'}
                                            breakClassName={'page-item'}
                                            breakLinkClassName={'page-link'}
                                            activeClassName={'active'}
                                        />
                                    </div>
                                </div>
                            )}

                        </div>
                    </div>
                </div>
            </div>


            {/* <OrganisationModal
                showModal={showModal}
                handleClose={handleCloseModal}
                orgId={selectedOrganisationId}
                orgData={selectedOrganisationData}
                addOrg={addOrganisation}
                editOrg={editOrganisation}
                orgs={contacts}
                fetchIndustries={fetchIndustries}
                errors={errors}
                setErrors={setErrors}
                industries={industries}

            // clientIdError={clientIdError}

            /> */}
            <OrganisationModal
                showModal={showSlideModal}
                handleClose={handleCloseModal}
                orgId={selectedOrganisationId}
                orgData={selectedOrganisationData}
                editOrg={editOrganisation}
                addOrg={addOrganisation}
                orgs={contacts}
                fetchIndustries={fetchIndustries}
                errors={errors}
                setErrors={setErrors}
                industries={industries}
            />
            {/* <OrganisationDetails
                showOffcanvas={showOffcanvas}
                handleClose={() => setShowOffcanvas(false)}
                organisationId={selectedOrganisationId}
            /> */}
            <OrganisationDetails
                showOffcanvas={showDetailsOffcanvas}
                handleClose={handleCloseDetails}
                organisationId={selectedOrganisationId}
                orgs={contacts}
                onOrganisationUpdate={() => fetchOrganisation(currentPage + 1)} // Refresh current page
            />
        </div>
    );
};

export default OrganisationList;